<!-- about -->
<template>
  <div class="safety-tips">
    <div class="banner">
      <div class="banner-text">
        <p class="title">{{$t('safety97')}}</p>
      </div>
    </div>
    <div class="banner-content">
      <p>{{$t('safety98')}}</p>
    </div>
    <div class="full-row">
      <dl class="img-text-warp">
        <!-- <dt class="pc"><img src="../assets/images/png-1.png" alt=""></dt> -->
        <dd class="margin-l">
          <div class="row-div">
            <p><img class="row-img" src="../assets/images/png-1.png" alt=""></p>
            <p class="row-title">{{$t('safety99')}}</p>
          </div>
          <p class="row-title-p">{{$t('safety100')}}</p>
          <p class="row-p row-left">{{$t('safety101')}}</p>
          <p class="row-title-p">{{$t('safety102')}}</p>
          <p class="row-p row-left">{{$t('safety103')}}</p>
          <p class="row-title-p">{{$t('safety104')}}</p>
          <p class="row-p row-left">{{$t('safety105')}}</p>
          <p class="row-p row-left">{{$t('safety106')}}</p>
          <p class="row-title-p">{{$t('safety107')}}</p>
          <p class="row-p row-left">{{$t('safety108')}}</p>
        </dd>
      </dl>
    </div>
    <div class="full-row">
      <dl class="img-text-warp">
        <dd class="margin-l">
          <div class="row-div">
            <p><img class="row-img" src="../assets/images/png-2.png" alt=""></p>
            <p class="row-title">{{$t('safety109')}}</p>
          </div>
          <p class="row-p">{{$t('safety110')}}</p>
          <p class="row-title-p">{{$t('safety111')}}</p>
          <p class="row-p row-left">{{$t('safety112')}}</p>
          <p class="row-title-p">{{$t('safety113')}}</p>
          <p class="row-p row-left">{{$t('safety114')}}<a target="_blank" href="https://support.livu.me/hc/en-us/requests/new?ticket_form_id=360003918394">Send a report</a></p>
        </dd>
      </dl>
    </div>
    <div class="full-row">
      <dl class="img-text-warp">
        <dd class="margin-l">
          <div class="row-div">
            <p><img class="row-img" src="../assets/images/png-3.png" alt=""></p>
            <p class="row-title">{{$t('safety115')}}</p>
          </div>
          <p class="row-p">{{$t('safety116')}}</p>
          <p class="row-title-p">{{$t('safety117')}}</p>
          <p class="row-p">{{$t('safety118')}}</p>
          <p class="row-p">{{$t('safety119')}}</p>
          <p class="row-p">{{$t('safety120')}}</p>
          <p class="row-title-p">{{$t('safety121')}}</p>
        </dd>
      </dl>
    </div>
    <div class="full-row">
      <dl class="img-text-warp">
        <dd class="margin-l">
          <div class="row-div">
            <p><img class="row-img" src="../assets/images/png-4.png" alt=""></p>
            <p class="row-title">{{$t('safety122')}}</p>
          </div>
          <p class="row-p">{{$t('safety123')}}</p>
          <p class="row-p"><a target="_blank" href="https://support.livu.me/hc/en-us/requests/new?ticket_form_id=360003918394">{{$t('safety124')}}</a></p>
          <p class="row-p">{{$t('safety125')}}</p>
        </dd>
      </dl>
    </div>
    <div class="full-row">
      <dl class="img-text-warp">
        <dd class="margin-r">
          <div class="row-div">
            <p><img class="row-img" src="../assets/images/png-5.png" alt=""></p>
            <p class="row-title">{{$t('safety126')}}</p>
          </div>
          <p class="row-p">{{$t('safety127')}}</p>
          <p class="row-p">{{$t('safety128')}}</p>
          <p class="row-p">{{$t('safety129')}}</p>
          <p class="row-p">{{$t('safety130')}}</p>
          <p class="row-a"><a target="_blank" href="https://withoutmyconsent.org">• {{$t('safety131')}}</a></p>
          <p class="row-a"><a target="_blank" href="https://www.womensaid.ie">• {{$t('safety132')}}</a></p>
          <p class="row-a"><a target="_blank" href="https://revengepornhelpline.org.uk">• {{$t('safety133')}}</a></p>
          <p class="row-a"><a target="_blank" href="https://www.helpwanted.nl">• {{$t('safety134')}}</a></p>
          <p class="row-a"><a target="_blank" href="https://www.csrindia.org">• {{$t('safety135')}}</a></p>
          <p class="row-a"><a target="_blank" href="https://www.csrindia.org">• {{$t('safety136')}}</a></p>
          <p class="row-a"><a target="_blank" href="https://www.csrindia.org">• {{$t('safety137')}}</a></p>
        </dd>
      </dl>
    </div>
    <div class="full-row">
      <dl class="img-text-warp">
        <dd class="margin-r">
          <div class="row-div">
            <p><img class="row-img" src="../assets/images/png-6.png" alt=""></p>
            <p class="row-title1">{{$t('safety138')}}</p>
          </div>
          <p class="row-p">{{$t('safety139')}}</p>
          <p class="row-p">{{$t('safety140')}}</p>
          <p class="row-p">{{$t('safety141')}}</p>
              <p class="row-p row-left">{{$t('safety142')}}</p>
              <p class="row-p row-left">{{$t('safety143')}}</p>
              <p class="row-p row-left">{{$t('safety144')}}</p>
          <p class="row-p"><a target="_blank" href="https://support.livu.me/hc/en-us/requests/new?ticket_form_id=360003918394">{{$t('safety145')}}</a></p>
        </dd>
      </dl>
    </div>
    <div class="full-row">
      <dl class="img-text-warp">
         <dd class="margin-l">
           <div class="row-div">
            <p><img class="row-img" src="../assets/images/png-7.png" alt=""></p>
            <p class="row-title row-title-content">{{$t('safety146')}}</p>
          </div>
          <p class="row-p">{{$t('safety147')}}
            <a target="_blank" href="https://support.livu.me/hc/en-us/requests/new?ticket_form_id=360003918394">{{$t('safety145')}}</a></p>
        </dd>
      </dl>
    </div>
      <div class="banner-text">
        <p class="title1">{{$t('safety148')}}</p>
        <p class="banner-content">{{$t('safety149')}}</p>
      </div>
    <div class="full-row">
      <dl class="img-text-warp">
        <dd class="margin-l">
          <div class="row-div">
            <p><img class="row-img" src="../assets/images/png-8.png" alt=""></p>
            <p class="row-title1">{{$t('safety150')}}</p>
          </div>
          <p class="row-p">{{$t('safety151')}}</p>
          <p class="row-p">{{$t('safety152')}}</p>
        </dd>
      </dl>
    </div>
    <div class="full-row">
      <dl class="img-text-warp">
         <dd class="margin-l">
           <div class="row-div">
            <p><img class="row-img" src="../assets/images/png-9.png" alt=""></p>
            <p class="row-title1">{{$t('safety153')}}</p>
          </div>
          <p class="row-a">{{$t('safety154')}}</p>
          <p class="row-a">{{$t('safety155')}}</p>
          <p class="row-a"><a target="_blank" href="http://www.befrienders.org/">• {{$t('safety156')}}</a></p>
          <p class="row-a"><a target="_blank" href="http:// www.thecalmzone.net">• {{$t('safety157')}}</a></p>
          <p class="row-a"><a target="_blank" href="https://giveusashout.org/">• {{$t('safety158')}}</a></p>
          <p class="row-a"><a target="_blank" href="https://www.113.nl/">• {{$t('safety159')}}</a></p>
          <p class="row-a"><a target="_blank" href="http://www.cvv.org.br/chat">• {{$t('safety161')}}</a></p>
          <p class="row-a"><a target="_blank" href="https://sergiourrego.org/">• {{$t('safety162')}}</a></p>
          <p class="row-a"><a target="_blank" href="https://www.openup.hk/">• {{$t('safety163')}}</a></p>
          <p class="row-a"><a target="_blank" href="https://www.mhlw.go.jp/">• {{$t('safety164')}}</a></p>
          <p class="row-a"><a target="_blank" href="https://www.fortishealthcare.com/india">• {{$t('safety165')}}</a></p>
          <p class="row-a"><a target="_blank" href="http://www.lifeline.org.au/">• {{$t('safety166')}}</a></p>
        </dd>
      </dl>
    </div>
    <div class="row-footer">
      <h2 class="title">{{$t('safety167')}}</h2>
      <p class="content">{{$t('safety168')}}<router-link to="/community-guidelines">{{$t('safety160')}}</router-link></p>
    </div>
    <backTop></backTop>
  </div>
</template>

<script>
import backTop from './back-top.vue'
export default {
  components: {
    backTop
  },
  name: 'safety-tips',
  data () {
    return {
    }
  }
}

</script>
<style lang='scss' scoped>
@import '@/assets/style/vars.scss';
@media (min-width: 750px) {
.to-top{
    width: 50px;
    height: 50px;
    position: fixed;
    right: 20px;
    bottom: 60px;
    background: center center / contain no-repeat transparent;
    transition: opacity 300ms ease 0s;
    cursor: pointer;
    z-index: 7;
}
.safety-tips {
  a{
    cursor: pointer;
  }
  margin-top: 20px;
  .banner-content{
    padding: 50px;
    font-size: 18px;
    text-align: left;
  }
  .banner {
    width: 100%;
    height: 500px;
    background: url('../assets/images/banner-2.png') no-repeat;
    background-size:  100% 100%;
  }
  .banner-text {
    width: 999px;
    margin: 0 auto;
    padding-top: 30px;
    p {
      margin-bottom: 15px;
      font-size: 24px;
      line-height: 28px;
      color: #5E5E5E;
    }
    .title {
      color: #ffffff;
      font-size: 45px;
      font-weight: bold;
      text-align: center;
      line-height: 400px;
      margin-bottom: 40px;
    }
    .title1{
      color: #0a0a0a;
      font-size: 45px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 40px;
    }
  }
  .full-row {
    width: 100%;
    padding: 80px 0;
    &:nth-child(odd) {
      background-color: #FAFAFA;
    }
    .img-text-warp {
      width: 990px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      dt {
        width: 408px;
        height: 381px;
      }
      dd {
        text-align: left;
      }
      .row-div{
        display: flex;
      }
      .row-img{
        width: 100px;
        height: 100px;
      }
      .row-title {
        font-size: 40px;
        font-weight: bold;
        color: #333;
        line-height: 100px;
        margin-bottom: 25px;
        margin-left: 10px;
      }
      .row-title1 {
        font-size: 40px;
        font-weight: bold;
        color: #333;
        line-height: 50px;
        margin-bottom: 25px;
        margin-left: 10px;
      }
      .row-title-p{
        font-size: 26px;
        line-height: 47px;
        font-weight: bold;
        color: #333;
        margin-bottom: 5px;
      }
      .row-p {
        color: #6B6B6B;
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 15px;
      }
      .row-a {
        color: #6B6B6B;
        font-size: 24px;
        line-height: 32px;
      }
      .row-left{
        margin-left: 22px;
      }
      .row-link {
        color: #1466ED;
        font-size: 24px;
      }
    }
  }
  .row-footer {
    width: 970px;
    margin: 30px auto 90px auto;
    .title {
      font-size: 40px;
      line-height: 47px;
      font-weight: bold;
      color: #333;
      margin-bottom: 25px;
    }
    .content {
      color: #6B6B6B;
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 15px;
    }
  }
  .margin-l {
    margin-left: 40px;
  }
  .margin-r {
    margin-right: 40px;
  }
  .mobile {
    display: none;
  }
}
}
@media (max-width: 750px) {
.to-top{
    width: 50px;
    height: 50px;
    position: fixed;
    right: 20px;
    bottom: 60px;
    background: center center / contain no-repeat transparent;
    transition: opacity 300ms ease 0s;
    cursor: pointer;
    z-index: 7;
}
.safety-tips {
  margin-top: 20px;
  .banner-content{
    padding: 10px 20px;
    font-size: 14px;
    text-align: left;
  }
  .banner {
   width: 100%;
    height: 150px;
    background: url('../assets/images/banner-2.png') no-repeat;
    background-size:  100% 100%;
  }
  .banner-text {
    padding: 25px;
    p {
      margin-bottom: 10px;
      font-size: 14px;
      line-height: 18px;
      color: #5E5E5E;
    }
    .title {
      color: #ffffff;
      font-size: 25px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 20px;
      line-height: 100px;
    }
    .title1{
      color: #0a0a0a;
      font-size: 25px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 20px;
    }
  }
  .full-row {
    width: 100%;
    padding: 40px 25px;
    &:nth-child(odd) {
      background-color: #FAFAFA;
    }
    .img-text-warp {
      dt {
        padding: 20px 30px 0 30px;
        img {
          max-width: 100%;
        }
      }
      dd {
        text-align: left;
      }
      .row-div{
        display: flex;
      }
      .row-img{
        width: 30px;
        height: 30px;
      }
      .row-title {
        font-size: 22px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
        margin-left: 10px;
      }
      .row-title1{
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
        margin-left: 10px;
      }
      .row-title-content{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
        margin-left: 10px;
      }
      .row-p {
        color: #6B6B6B;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 8px;
      }
      .row-a {
        color: #6B6B6B;
        font-size: 14px;
        line-height: 18px;
      }
      .row-link {
        color: #1466ED;
        font-size: 14px;
      }
    }
  }
  .margin-l {
    margin-left: 0;
  }
  .margin-r {
    margin-right: 0;
  }
  .safety-list {
    width: 100%;
    padding: 30px 0;
    background-color: #FAFAFA;
    .safe-title {
      font-weight: bold;
      font-size: 22px;
      color: #333;
      text-align: center;
    }
    .list-warp{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding:20px 25px;
      li {
        width: 150px;
        height: 78px;
        background-color: #ffffff;
        margin-top: 25px;
      }
    }
  }
  .row-footer {
    padding: 25px 25px 50px 25px;
    .title {
      font-size: 22px;
      line-height: 25px;
      font-weight: bold;
      color: #333;
      margin-bottom: 10px;
    }
    .content {
      color: #6B6B6B;
      font-size: 14px;
      line-height: 16px;
    }
  }
  .pc {
    display: none;
  }
}
}
</style>
